import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //store offer letter
  offerLetterDataStudent: {},

  //store the upload response
  panData: {},
  passportDataFrontStudent: {},
  passportDataFrontRemitters: {},
  passportDataBackStudent: {},
  passportDataBackRemitters: {},
  aadhaarDataFrontStudent: {},
  aadhaarDataFrontRemitters: {},
  aadhaarDataBackStudent: {},
  aadhaarDataBackRemitters: {},

  //store the document data
  panDoc: {},
  passportDocFrontStudent: {},
  passportDocFrontRemitters: {},
  passportDocBackStudent: {},
  passportDocBackRemitters: {},
  aadhaarDocFrontStudent: {},
  aadhaarDocFrontRemitters: {},
  aadhaarDocBackStudent: {},
  aadhaarDocBackRemitters: {},
  loading: false,
  error: null,
};

export const docSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    panSuccess: (state, action) => {
      state.panData = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportFrontSuccessStudent: (state, action) => {
      state.passportDataFrontStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportFrontSuccessRemitters: (state, action) => {
      state.passportDataFrontRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportBackSuccessStudent: (state, action) => {
      state.passportDataBackStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportBackSuccessRemitters: (state, action) => {
      state.passportDataBackRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarFrontSuccessStudent: (state, action) => {
      state.aadhaarDataFrontStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarFrontSuccessRemitters: (state, action) => {
      state.aadhaarDataFrontRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarBackSuccessStudent: (state, action) => {
      state.aadhaarDataBackStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarBackSuccessRemitters: (state, action) => {
      state.aadhaarDataBackRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    panDocSuccess: (state, action) => {
      state.panDoc = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportDocFrontSuccessStudent : (state, action) => {
      state.passportDocFrontStudent  = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportDocFrontSuccessRemitters: (state, action) => {
      state.passportDocFrontRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportDocBackSuccessStudent: (state, action) => {
      state.passportDocBackStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    passportDocBackSuccessRemitters: (state, action) => {
      state.passportDocBackRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarDocFrontSuccessStudent: (state, action) => {
      state.aadhaarDocFrontStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarDocFrontSuccessRemitters: (state, action) => {
      state.aadhaarDocFrontRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarDocBackSuccessStudent: (state, action) => {
      state.aadhaarDocBackStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    aadhaarDocBackSuccessRemitters: (state, action) => {
      state.aadhaarDocBackRemitters = action.payload;
      state.loading = false;
      state.error = null;
    },
    //offer letter s3 storing 
    offerLetterSuccessStudent: (state, action) => {
      state.offerLetterDataStudent = action.payload;
      state.loading = false;
      state.error = null;
    },
    docLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    docError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetDocuments: (state) => {
      state.panData = {};
      state.passportDataFrontStudent = {};
      state.passportDataBackStudent = {};
      state.aadhaarDataFrontStudent = {};
      state.aadhaarDataBackStudent = {};
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  docLoading,
  docError,
  resetDocuments,
  panSuccess,
  passportFrontSuccessStudent,
  passportFrontSuccessRemitters,
  passportBackSuccessStudent,
  passportBackSuccessRemitters,
  aadhaarFrontSuccessStudent,
  aadhaarFrontSuccessRemitters,
  aadhaarBackSuccessStudent,
  aadhaarBackSuccessRemitters,
  panDocSuccess,
  passportDocFrontSuccessStudent,
  passportDocFrontSuccessRemitters,
  passportDocBackSuccessStudent,
  passportDocBackSuccessRemitters,
  aadhaarDocFrontSuccessStudent,
  aadhaarDocFrontSuccessRemitters,
  aadhaarDocBackSuccessStudent,
  aadhaarDocBackSuccessRemitters,
  offerLetterSuccessStudent,
} = docSlice.actions;

export default docSlice.reducer;
